"use client";
import { ButtonComponent, ModalComponent } from "@/components";
import {
  IMAGES,
  WEB_COLORS,
} from "@/lib/constants";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import Image from "next/image";

const LogoutConfirmationModal = ({ onSubmit, onReject, open }) => {
  const isMobile = useMediaQuery("(max-width:900px)");

  return (
    <ModalComponent
      maxWidth={isMobile ? "sm" : "md"}
      contentSx={{
        px: 2,
        py: 1.5,
        borderRadius: "12px",
      }}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          maxWidth: { xs: "377px", md: "900px" },
        },
      }}
      open={open}
      closeButtonRequired={false}>
      <Stack
        spacing={2}
        direction={{ xs: "column", md: "row" }}
        sx={{
          borderRadius: "12px",
          overflow: "hidden",
        }}
        alignItems="center"
        justifyContent="center"
        width="100%">
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            aspectRatio: 1,
            maxHeight: { xs: "280px", md: "425px" },
            bgcolor: WEB_COLORS.paleGreen,
            position: "relative",
            bgcolor: WEB_COLORS.paleGreen,
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <Image
            src={IMAGES.logoutLoan}
            unoptimized
            alt="Logout Confirmation"
            fill
            style={{ objectFit: "contain" }}
          />
        </Box>

        <Stack
          spacing={3}
          alignItems="center"
          justifyContent="center"
          sx={{
            width: { xs: "100%", md: "50%" },
            px: { xs: 2, md: 4 },
          }}>
          <Stack gap={1}>
            <Typography
              fontWeight={700}
              color={WEB_COLORS.primary}
              sx={{ fontSize: { xs: 16, md: 24 } }}>
              Are you sure you want to log out?
            </Typography>

            <Typography
              fontWeight={400}
              color={WEB_COLORS.textFadeColor}
              sx={{ fontSize: { xs: 12, md: 16 } }}>
              You are very close to getting your loan sanctioned!
            </Typography>
          </Stack>

          <Stack gap={1} width="100%" flexGrow={1}>
            <ButtonComponent onClick={onSubmit}>Logout</ButtonComponent>
            <ButtonComponent
              variant="outlined"
              sx={{
                bgColor: WEB_COLORS.paleSkyBlue,
                flexGrow: 1,
                py: "16px",
                px: "24px",
                textTransform: "capitalize",
                borderRadius: "6px",
              }}
              onClick={onReject}>
              Cancel
            </ButtonComponent>
          </Stack>
        </Stack>
      </Stack>
    </ModalComponent>
  );
};

export default LogoutConfirmationModal;
